import { default as ReactSelect } from "react-select";
import { components } from "react-select";
const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        {/* <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        /> */}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const MultiSelectBox = (props) => {
  const handleChange = (selected) => {
    props?.updateValue({
      value: selected,
      name: props?.name,
    });
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      fontSize: "16px",
      color: "#fff",
    }),
    option: (base, { isSelected, isFocused }) => ({
      ...base,
      color: isSelected ? "#fff" : isFocused ? "#000" : null,
      cursor: "pointer",
      background: isSelected ? "#004D40" : isFocused ? "#fff" : null,
      "&:hover": {
        background: "#004D40",
        color: "#fff",
      },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#004D40",
      borderRadius: "11px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#fff",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#fff",
      // ":hover": {
      //   backgroundColor: "#e4e7eb",
      //   color: "#004D40",
      //   borderRadius:"11px"
      // },
    }),
  };
  return (
    <div
      className={`${props.divClass || "col-lg-6 col-md-12"}`}
      data-toggle="popover"
      data-trigger="focus"
      data-content="Please select account(s)"
    >
      <label htmlFor={`multiselect-${props?.name}`}>
        {props?.title}
        {props?.isMandatory ? <span className="required">*</span> : ""}
      </label>
      <ReactSelect
        value={props?.value || null}
        options={props?.options}
        onChange={handleChange}
        isMulti={props?.isMultiSelect}
        closeMenuOnSelect={props?.closeListOnSelect}
        hideSelectedOptions={props?.hideSelectedOptions}
        components={{ Option }}
        allowSelectAll={true}
        styles={selectStyles}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: "#004D40",
            primary: "#004D40",
          },
        })}
      />
    {props.errors && props.errors.map(error => (<div className="invalid-input">{error}</div>))}
    </div>
  );
};

export default MultiSelectBox;
